import React from 'react';
import { Link } from 'react-router-dom';

import img from '../../assets/laptop.png';

import styles from './Hero.scss';

const Hero = () => {
  return (
    <div className={styles.Hero}>
      <div className={styles.Text}>
        <h3 className={styles.row1}>THE FASTEST WAY TO HIRE SALES TALENT</h3>

        <h1 className={styles.row2}>
          {
            'No more wading through bad fits. Rainmakers gives you curated candidates without the noise, fluff, or delay.'
          }
        </h1>

        <Link className={styles.Request} to="/employer-signup/">
          Join Now
        </Link>
      </div>
      <img src={img} alt="laptop image" />
    </div>
  );
};

export default Hero;
